<!-- 调账单列表项组件 -->
<template>
  <div class="wrap" @click="$emit('click')">
    <header class="wrap_header">
      <span class="bills">单据：{{ number }}</span>
    </header>
    <div class="wrap_box">
      <div class="wrap_box_item">
        <span class="text">调账金额：</span>
        <span class="des" :style="{color: changeReceivableType >= 0 ? '#f66c6c' : '#54c178'}">¥{{ sum }}</span>
      </div>
      <div class="wrap_box_item">
        <span class="text">调账类型：</span>
        <span class="des">{{ changeReceivableType >= 0 ? '应收款增加' : '应收款减少' }}</span>
      </div>
      <div class="wrap_box_item">
        <span class="text">制单时间：</span>
        <span class="des">{{ dateTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };

  },

  //接收参数
  props: {
    number: String,
    sum: Number,
    changeReceivableType: Number,
    dateTime: String
  },

  methods: {}
}

</script>
<style lang='scss' scoped>
.wrap {
  width: 9.2rem;
  background: #ffffff;
  box-shadow: 0rem 0.013333rem 0.026667rem 0rem #ebebeb;
  border-radius: 0.266667rem;
  box-sizing: border-box;
  padding-bottom: 0.15rem;
}
.wrap_header {
  display: flex;
  justify-content: space-between;
  padding: 0.466667rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;
}
.bills {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.wrap_box {
  padding: 0.32rem 0.32rem 0 0.32rem;
}
.wrap_box_item {
  height: 0.32rem;
  line-height: 0.32rem;
  padding-bottom: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.des {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  padding-right: 2px;
}
</style>